<template>
  <!-- Modal other files -->
  <div
    class="modal fade"
    id="us-tax-package-confirmation"
    tabindex="-1"
    role="dialog"
    aria-labelledby="usTaxPackageConfirmation"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div>
          <div class="modal-header">
            <span class="modal-title-new" id="termsLabel">{{
              $t('Vergi paketinize eklenecek ürünler var, onaylıyor musunuz')
            }}</span>

            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
          </div>
          <div class="modal-body modal-body-min">
            <div class="alert-field-new">
              <div>
                <img src="/img/icons/goal.svg" alt="" />
              </div>
              <span class="alert-text-new">
                {{
                  $t('Şirket tipi ve ortak sayısına göre verilmesi gereken beyan sayıları değişiklik göstermektedir')
                }}
              </span>
            </div>
            <div class="recommend-field">
              <div class="recommend-main-field">
                <div class="recommend-badge-field">
                  <div>
                    <img src="/img/icons/note.svg" alt="" />
                  </div>
                  <span>
                    {{
                      $t('US Vergi Onay Text', { shareholderCount: shareholderCount + 1, companyType: companyType })
                    }}</span
                  >
                </div>
                <div class="recommend-inner-field">
                  <div
                    v-for="(product, index) in mergedCalculatedProducts"
                    :key="index"
                    class="recommend-inner-item mt-2"
                  >
                    <span class="product-name-new">{{ getProductName(product) }}</span>
                    <span class="new-price"
                      >{{ formatPrice(product.net_price, product.currency) }}
                      {{
                        product.type === 'subscription'
                          ? product.period === 'annual'
                            ? ' /' + $t('Yıl')
                            : ' /' + $t('Ay')
                          : ''
                      }}</span
                    >
                  </div>
                  <hr class="my-3" />

                  <div class="recommend-inner-item">
                    <span class="product-total-new">{{ $t('Toplam') }}</span>
                    <span class="new-price total">{{ formatPrice(subtotal, symbol) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer wrap-footer">
          <button type="button" class="btn button-type-outline-light" data-dismiss="modal">
            {{ $t('Gözden Geçirmek İstiyorum') }}
          </button>
          <button @click="confirm" type="button" class="btn btn-mukellef" data-dismiss="modal">
            {{ $t('Devam Et') }}
          </button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
  <!-- Modal terms -->
</template>
<script>
export default {
  name: 'usTaxPackageConfirmation',
  props: {
    usProducts: {
      type: Array,
      default: () => [],
    },
    company: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      product1040nr: {},
      itinProduct: {},
      product1065: {},
      product1120: {},
      calculatedProducts: [],
    };
  },
  computed: {
    symbol() {
      if (this.company && this.company.currency) {
        return this.company.currency.symbol;
      }
      return null;
    },
    mergedCalculatedProducts() {
      if (this.calculatedProducts && this.calculatedProducts.length) {
        const merged = Object.values(
          this.calculatedProducts.reduce((acc, item) => {
            if (acc[item.code]) {
              acc[item.code].net_price += item.net_price;
            } else {
              acc[item.code] = { ...item };
            }
            return acc;
          }, {})
        );
        return merged;
      }

      return [];
    },
    subtotal: function () {
      let finalPrice = 0;

      if (this.mergedCalculatedProducts && this.mergedCalculatedProducts.length > 0) {
        finalPrice = this.mergedCalculatedProducts.reduce((total, price) => total + price.net_price, 0);
      }
      return finalPrice;
    },
    companyType() {
      if (this.company && this.company.id && this.company.companyType.data.code) {
        return this.company.companyType.data.code;
      }
      return null;
    },
    shareholderCount() {
      if (this.company && this.company.partnership_details && this.company.partnership_details.length) {
        return this.company.partnership_details.length;
      }
      return null;
    },
  },
  methods: {
    calculateProducts() {
      this.calculatedProducts = [];
      const product1040nr = this.usProducts.find((product) => product.code === 'US_1040_NR_FORM');
      if (product1040nr) {
        product1040nr.net_price = this.getPrice(product1040nr.prices.data);
        this.product1040nr = product1040nr;
      }

      const itinProduct = this.usProducts.find((product) => product.code === 'USITIN');
      if (itinProduct) {
        itinProduct.net_price = this.getPrice(itinProduct.prices.data);
        this.itinProduct = itinProduct;
      }

      if (this.companyType === 'LLC') {
        const product1065 = this.usProducts.find((product) => product.code === 'US_1065_FORM');
        if (product1065) {
          product1065.net_price = this.getPrice(product1065.prices.data);
          this.product1065 = product1065;
        }
      } else {
        const product1120 = this.usProducts.find((product) => product.code === 'US_1120_FORM');
        if (product1120) {
          product1120.net_price = this.getPrice(product1120.prices.data);
          this.product1120 = product1120;
        }
      }

      if (this.companyType === 'LLC') {
        if (this.shareholderCount) {
          this.calculatedProducts.push(this.product1065);
          for (let index = 0; index < this.shareholderCount; index++) {
            this.calculatedProducts.push(this.itinProduct);
            this.calculatedProducts.push(this.product1040nr);
          }
        }
      } else {
        this.calculatedProducts.push(this.product1120);
        for (let index = 0; index < this.shareholderCount; index++) {
          this.calculatedProducts.push(this.itinProduct);
          this.calculatedProducts.push(this.product1040nr);
        }
      }
    },
    getProductsArray() {
      return this.calculatedProducts.map((item) => item.code);
    },
    getPrice(prices) {
      const product = prices.find((x) => x.company_type_id === this.company.company_type_id);
      if (product) {
        return product.price;
      }
    },
    confirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="less" scoped>
.modal-dialog {
  max-width: 659px !important;
  padding: 8px !important;
}
.alert-field-new {
  background: rgba(0, 170, 107, 0.1);
  border-radius: 12px;
  border: 1px solid #ddd;
  padding: 16px;
  display: flex;
  gap: 8px;
}

.modal-title-new {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  font-weight: 500;
  color: black;
}
.recommend-field {
  background: white;
  box-shadow: 0px 1px 39.1px 0px rgba(165, 165, 165, 0.25);
  border-radius: 16px;
  border: 1px solid #ddd;
  padding: 24px;
  margin-top: 24px;

  gap: 8px;
}
.recommend-inner-field {
  padding: 12px;
  border-radius: 16px;
  border: 1px solid #ddd;
  margin-top: 8px;
}
.recommend-inner-item {
  display: flex;
  gap: 2;
  justify-content: space-between;
}
.recommend-badge-field {
  padding: 4px;
  background: #00aa6b;
  display: inline-flex;
  gap: 8px;
  border-radius: 4px;
  font-size: 14px;
  line-height: 21px;
  color: white;
  font-weight: 500;
}
.product-name-new {
  font-size: 14px;
  line-height: 21px;
  font-weight: 500;
  color: black;
}
.product-total-new {
  font-size: 14px;
  line-height: 21px;
  font-weight: 500;
  color: #f6576e;
}
.new-product-features {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
  .new-product-feature-item {
    background: #f1fafe;
    padding: 4px 12px 4px 8px;
    text-align: center;
    border-radius: 4px;
    font-size: 14px;
    line-height: 21px;
    color: black;
    font-weight: 500;
  }
}
.recommend-price-field {
  align-self: flex-end;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  padding: 8px;
}
.new-price {
  color: black;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
}
</style>

<style lang="less">
.fadeonly-enter-active,
.fadeonly-leave-active {
  transition: opacity 0.6s ease;
}

.fadeonly-enter-from,
.fadeonly-leave-to {
  opacity: 0;
}
</style>
